import { AuthenticationService } from './authentication.service';
import { Settings } from './settings';
import { AuthConfig } from '../modal/AuthConfig';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, tap, take } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
/**
 * This guard is an example of how you would provide a `AuthConfig` to the `AuthenticationService`.
 * This is just one way, not the only way. Note that as of now (v1.0.0) if you call login multiple times for different configs
 * unexpected things may happen. I have a hunch that it has to do with SalteAuth's use of SessionStorage and Cookies, but I'm not positive.
 * For now, avoid letting users switch `AuthConfig`s
 */
@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(private authenticationService: AuthenticationService,private setting:Settings,private auth: AuthService, private router: Router) {
    
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.auth.isAuthenticated$.pipe(
      // take(1), // Take only the first emitted value and complete the observable
      map(loggedIn => {
        if (!loggedIn) {
          this.authenticationService.login();
          return true;
        }
        return true;
      })
    );
  }

}
